import Component from 'component';
import slick from '../plugins/slick';
import imagesloaded from 'imagesloaded';
import _isEmpty from 'lodash/isEmpty';
import _debounce from 'lodash/debounce';
import {
  BREAKPOINT
} from '../constants/index';
import { jumpToTarget } from '../helpers/jumpToTarget';

class ProductsGallery extends Component {
  constructor(el) {
    super(el);
    this.initGallery();
    this.initNavSlick();
    this.initMainSlick();
    this.checkHash();
  }

  setupDefaults() {
    this.dom = {
      $prodGallery: this.$el.find('.prod-gallery.has-social-links'),
      $slider: this.$el.find('.js-prod-gallery'),
      $sliderContainer: this.$el.find('.prod-gallery__inner'),
      $sliderNav: this.$el.find('.js-prod-gallery-nav'),
      $dotsContainer: this.$el.find('.prod-gallery__carousel-dots'),
      $socialLinks: this.$el.find('.addthis_share_button'),
      $socialContainer: this.$el.find('.social-links')
    };
  }

  addListeners() {
    this.dom.$slider.on('init reinit breakpoint afterChange', ::this.onAlignElements);
    this.dom.$slider.on('afterChange', ::this.updateSocialLinks);

    $(window).on('resize', _debounce(::this.onAlignElements, 250));
    $(window).on('resize', ::this.onResize);
  }

  onAlignElements(event, $slick) {
    let $prodSlider;

    if (typeof $slick === 'undefined') {
      $prodSlider = this.dom.$slider;
      $slick = $prodSlider.slick('getSlick');
    } else {
      $prodSlider = $slick.$slider;
    }

    this.alignArrows($prodSlider);
    this.positionSocial($prodSlider);
    this.updateSocialLinks(event, $slick, $slick.currentSlide);
  }

  onResize() {
    this.dom.$slider.slick('setPosition');
    this.dom.$sliderNav.slick('setPosition');
  }

  initGallery() {
    if (this.dom.$socialContainer.length > 0) {
      this.$el.addClass('has-social-links');
    }
  }

  initMainSlick() {
    const _that = this;
    $(this.dom.$prodGallery).hide();
    //Main Carousel
    this.dom.$slider.slick({
      infinite: true,
      accessibility: true,
      dots: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: _that.dom.$sliderNav,
      waitForAnimate: false,
      prevArrow: '<img class="slick-prev slick-arrow" src="/dist/sites/btu/images/contentManaged/icons/icon-arrow-left-shadow.svg" alt="prev slide">',
      nextArrow: '<img class="slick-next slick-arrow" src="/dist/sites/btu/images/contentManaged/icons/icon-arrow-right-shadow.svg" alt="next slide">'
    });
    // Because Safari does not work reliably with the slick LazyLoaded event, we are using afterChange.
    // But, afterChange does not fire until a slide changes causing the first slide arrows and social icons to be misaligned.
    // The below code will quickly change to the next slide and then back to the first on page load.
    // This should be unnoticable to the user.
    const firstImg = $(this.dom.$slider).find('.prod-gallery__slide-img-wrapper')[1];
    const imgLoad = imagesloaded(firstImg, () => {
      this.alignArrows(this.dom.$slider)
      this.positionSocial(this.dom.$slider);
      this.dom.$slider.slick('slickNext').slick('slickPrev');
      this.alignArrows(this.dom.$slider)
      this.positionSocial(this.dom.$slider);
    });
  }
  initNavSlick() {
    const _that = this;
    //Carousel Nav
    _that.dom.$sliderNav.slick({
      infinite: true,
      accessibility: true,
      dots: true,
      arrows: true,
      prevArrow: '<img class="slick-prev slick-arrow" src="/dist/sites/btu/images/contentManaged/icons/icon-arrow-left-shadow.svg" alt="prev slide">',
      nextArrow: '<img class="slick-next slick-arrow" src="/dist/sites/btu/images/contentManaged/icons/icon-arrow-right-shadow.svg" alt="next slide">',
      appendDots: _that.dom.$dotsContainer,
      slidesToShow: 5,
      slidesToScroll: 5,
      asNavFor: _that.dom.$slider,
      focusOnSelect: true,
      centerMode: false,
      responsive: [{
        breakpoint: BREAKPOINT.tablet,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }]
      //prevArrow: '<img class="slick-prev slick-arrow" src="/dist/sites/btu/images/icons/icon-arrow-left.svg" alt="prev slide">',
      //nextArrow: '<img class="slick-next slick-arrow" src="/dist/sites/btu/images/icons/icon-arrow-right.svg" alt="next slide">'
    });
  }

  updateSocialLinks(event, slick, currentSlideIndex) {
    const _that = this;
    //Initialize or breakpoint event, get info from first slide
    const $currentSlide = $(slick.$slides.get(slick.currentSlide));
    const shareInfo = {};

    shareInfo['url'] = `${window.location.origin}${window.location.pathname}?slide=${$currentSlide.data('guid')}${window.location.hash}`;
    shareInfo['media'] = `${window.location.origin}${$currentSlide.data('imgUrl')}`;
    shareInfo['title'] = $currentSlide.data('shareTitle');
    shareInfo['description'] = $currentSlide.data('shareDescription');
    this.dom.$socialLinks.each((index, element) => {
      _that.updateSocialShareInfo($(element), shareInfo);
    })
  }

  updateSocialShareInfo($socialLink, dataInfo) {
    if (!(_isEmpty(dataInfo))) {

      for(const key in dataInfo) {
        if ({}.hasOwnProperty.call(dataInfo, key)) {
          $socialLink.attr(`data-${key}`, dataInfo[key]);
        }
      }
    }
  }

  alignArrows($prodSlider) {
    if (!window.matchMedia(`screen and (min-width: ${  BREAKPOINT.tablet  }px)`).matches) {
      const topPos = $prodSlider.find('.slick-active .prod-gallery__slide-img-wrapper').height() / 2;

      $('.prod-gallery__carousel .slick-arrow').css('top', `${topPos}px`);
    } else {
      $('.prod-gallery__carousel .slick-arrow').css('top', '50%');
    }
  }

  positionSocial($prodSlider) {
    if (!window.matchMedia(`screen and (min-width: ${  BREAKPOINT.tablet  }px)`).matches) {
      const imgHeight = $prodSlider.find('.slick-active .prod-gallery__slide-img-wrapper').height();

      const imgWidth = $prodSlider.find('.slick-active .prod-gallery__slide-img-wrapper').width();

      let topPos = 0;
      topPos = imgHeight;
      this.dom.$socialContainer.css('top', `${topPos}px`);
    } else {
      this.dom.$socialContainer.css('top', 'auto');
    }
  }

  checkHash() {
    const slideId = this.getUrlParameter('slide');

    if (window.location.hash) {
      const $selectedSlide = this.$el.find(`[data-guid="${slideId}"]`).first();
      const slideIndex = $selectedSlide.data('slick-index');

      if ($selectedSlide.length > 0) {
        const $parentSlider = $selectedSlide.closest('.slick-slider');
        $parentSlider.slick('slickGoTo', parseInt(slideIndex), true);
        jumpToTarget(document.querySelector('div.prod-gallery__inner'));
      }
    }
  }
  getUrlParameter(sParam) {
    const sPageURL = window.location.search.substring(1);
    const sURLVariables = sPageURL.split('&');

    let sParameterName, i;

    for(i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        // eslint-disable-next-line no-undefined
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  }
}

export default ProductsGallery;



// WEBPACK FOOTER //
// ./src/btu/js/components/ProductsGallery.js